/**
 * @file Frontend API client — eventService.
 */

import axiosClient from "../api/axiosClient";

/** Type definition — Public Event. */
export interface PublicEvent {
  id: number;
  title: string;
  content: string;
  eventDate: string;
  place: string;
  image: string | null;
  registrationLink: string | null;
  createdAt?: string;
}

/** Type definition — List Events Response. */
export interface ListEventsResponse<T> {
  success: boolean;
  data: T[];
}

/** Exported const — event Service. */
export const eventService = {
  async listActive() {
    return axiosClient.get<ListEventsResponse<PublicEvent>>("/events");
  },
};

